import api from './base'

export default {
    getGlobalSettings () {
        return api().get(`global_settings`)
    },
}